module.exports = __webpack_public_path__ + "img/dsci0058.3a4c2853.jpg";